/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CallPassCharts from './CallPassCharts'; // Import the new chart component
 
const CallPassBrandedCallingSummary = () => {
    const location = useLocation();
    // 'initialFilters' holds filter values passed from another page
    const { initialFilters } = location.state || {};

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [cid, setCid] = useState('');
    const [expire, setExpire] = useState('');  
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [callPassBrandedCallingAccess, setCallPassBrandedCallingAccess] = useState(false);
    const [userCallPassBrandedCallingAccess, setUserCallPassBrandedCallingAccess] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);
    const [company, setCompany] = useState([]);
    const [timeZone, seTimeZone] = useState('');
    const [displayTimezone, setDisplayTimezone] = useState(initialFilters?.displayTimezone || 'UTC');
    const [pendingDisplayTimezone, setPendingDisplayTimezone] = useState(initialFilters?.displayTimezone || 'UTC');

    // Date and Time range filters
    const getYesterday = () => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return yesterday;
    };
    // Initialize filter states:
    // 1. From 'initialFilters' if present (e.g., coming from Details page).
    // 2. Else, use default values.
    const [startDate, setStartDate] = useState(
        initialFilters?.startDate ? new Date(initialFilters.startDate) : getYesterday()
    );
    const [endDate, setEndDate] = useState(
        initialFilters?.endDate ? new Date(initialFilters.endDate) : new Date()
    );
    const [startTime, setStartTime] = useState(initialFilters?.startTime || "00:00");
    const [endTime, setEndTime] = useState(initialFilters?.endTime || "23:59");
    const [selectedCompany, setSelectedCompany] = useState(initialFilters?.selectedCompany || "");

    // Other filters
    const [selectedEntity, setSelectedEntity] = useState(initialFilters?.selectedEntity || "");
    const [selectedDisplayIdentity, setSelectedDisplayIdentity] = useState(initialFilters?.selectedDisplayIdentity || "");
    const [selectedOrigationNumber, setSelectedOrigationNumber] = useState(initialFilters?.selectedOrigationNumber || "");
    

    // Options for filters (to be fetched from API)
    const [entityOptions, setEntityOptions] = useState([]);
    const [displayIdentityOptions, setDisplayIdentityOptions] = useState([]);
    const [origationNumberOptions, setOrigationNumberOptions] = useState([]);

    // Summary Data
    const [summaryData, setSummaryData] = useState([]);

    // State for chart drilldown
    const [selectedDisplayIdentityForDrilldown, setSelectedDisplayIdentityForDrilldown] = useState(null);
    const isInitialPageLoadForAutoApply = React.useRef(true); // Ref to track initial auto-apply

    const handleDisplayIdentityClick = (payload) => {
        // If we click the same bar again, toggle off the drill-down.
        if (selectedDisplayIdentityForDrilldown && payload && selectedDisplayIdentityForDrilldown.label === payload.label) {
            setSelectedDisplayIdentityForDrilldown(null);
        } else {
            // Otherwise, set the new selection for drill-down.
            setSelectedDisplayIdentityForDrilldown(payload);
        }
    };

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        getUserCompany();
    }, []);

    useEffect(() => {
        if(cid){
            checkPageAccess();
        }
    }, [cid]);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    useEffect(() => {
        if(role >= 3 && cid){
            setSelectedCompany(cid);
        }
    }, [cid, role]);

    // Effect to auto-apply filters on initial load if selectedCompany is present from initialFilters
    useEffect(() => {
        if (
            
            isInitialPageLoadForAutoApply.current &&
            (role >= 3 || (role <= 2 && initialFilters?.selectedCompany)) && // Check if a company was passed initially
            selectedCompany && // Ensure state is also updated (should match initialFilters)
            token &&
            cid &&
            callPassBrandedCallingAccess &&
            userCallPassBrandedCallingAccess
        ) {
            console.log("Initial load with selectedCompany, applying filters automatically for Summary page.");
            handleApplyFilters();
            isInitialPageLoadForAutoApply.current = false; // Prevent re-triggering
        }
    }, [
        initialFilters?.selectedCompany,
        selectedCompany,
        token,
        cid,
        role,
        callPassBrandedCallingAccess,
        userCallPassBrandedCallingAccess,
    ]);


    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
            seTimeZone(decoded.timezone);
        } catch (error) {
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    
    const checkPageAccess = async () => {
        try {
            incrementLoading();
            // Fetch all required data            
            const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            const callPassBrandedCallingSwitch = customerDigitMappingResponse.data.call_pass_branded_calling_switch;
            const userCallPassBrandedCallingSwitch = userAccessResponse.data.user_call_pass_branded_calling_switch;
            decrementLoading();
            setAccess(userAccessResponse.data.results);
            // Conditional check for access
            if (
                callPassBrandedCallingSwitch >= 1 &&
                userCallPassBrandedCallingSwitch >= 1
            ) {
                setUserCallPassBrandedCallingAccess(userCallPassBrandedCallingSwitch >= 1);
                setCallPassBrandedCallingAccess(callPassBrandedCallingSwitch >= 1);
                // Proceed with page logic
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Error checking page access:", error);
            navigate('/dashboard'); // Redirect in case of any error
        }
    };

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const company = response.data.filter(item => item.id !== 1);
        // company.shift();
        // console.log(response.data);
        setCompany(company);
    }

    const formatDateToYYYYMMDD = (date) => {
        if (!date) return ''; // Handle null or undefined dates
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Timezone mapping from abbreviation to IANA timezone identifier
    const timezoneMap = {
        'PST': 'America/Los_Angeles',
        'PDT': 'America/Los_Angeles',
        'MST': 'America/Denver',
        'MDT': 'America/Denver',
        'CST': 'America/Chicago',
        'CDT': 'America/Chicago',
        'EST': 'America/New_York',
        'EDT': 'America/New_York',
        'UTC': 'UTC',
        'GMT': 'UTC'
    };

    // Convert user's local date/time to UTC
    const convertToUTC = (date, time, userTimezone) => {
        if (!date || !time) return { utcDate: '', utcTime: '' };
    
        const ianaTimezone = timezoneMap[userTimezone] || userTimezone;
    
        // If user timezone is UTC, no conversion is needed
        if (ianaTimezone === 'UTC' || ianaTimezone === 'GMT') {
            return {
                utcDate: formatDateToYYYYMMDD(date),
                utcTime: time,
            };
        }
    
        // 1. Create a date object from the user's input, treated as UTC for now.
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const [hour, minute] = time.split(':').map(Number);
    
        const inputAsUtc = new Date(Date.UTC(year, month, day, hour, minute));
    
        // 2. Format this UTC date into the user's selected timezone to see what "wall time" it corresponds to there.
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: ianaTimezone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });
    
        const parts = formatter.formatToParts(inputAsUtc);
        const getPart = (type) =>
            parseInt(parts.find((p) => p.type === type)?.value, 10);
    
        // 3. Create a new UTC date from these formatted parts.
        // The month part from Intl is 1-based, so subtract 1 for the Date constructor.
        const wallTimeInTzAsUtc = new Date(
            Date.UTC(
                getPart('year'),
                getPart('month') - 1,
                getPart('day'),
                getPart('hour') === 24 ? 0 : getPart('hour'), // Handle 24h case
                getPart('minute')
            )
        );
    
        // 4. The difference between our initial UTC date and this new one is the timezone offset.
        const offset = inputAsUtc.getTime() - wallTimeInTzAsUtc.getTime();
    
        // 5. Add the offset to our initial UTC date to get the correct target UTC time.
        const finalUtcDate = new Date(inputAsUtc.getTime() + offset);
    
        // 6. Format the final, correct UTC date into strings for the API.
        const utcYear = finalUtcDate.getUTCFullYear();
        const utcMonth = String(finalUtcDate.getUTCMonth() + 1).padStart(2, '0');
        const utcDay = String(finalUtcDate.getUTCDate()).padStart(2, '0');
        const utcHour = String(finalUtcDate.getUTCHours()).padStart(2, '0');
        const utcMinute = String(finalUtcDate.getUTCMinutes()).padStart(2, '0');
    
        return {
            utcDate: `${utcYear}-${utcMonth}-${utcDay}`,
            utcTime: `${utcHour}:${utcMinute}`,
        };
    };

    // Convert UTC date/time to user's local timezone for display
    const convertFromUTC = (utcDateStr, utcTimeStr, userTimezone) => {
        if (!utcDateStr) return { localDate: '', localTime: '' };

        // If user timezone is UTC, no conversion needed
        if (userTimezone === 'UTC' || userTimezone === 'GMT') {
            return {
                localDate: utcDateStr,
                localTime: utcTimeStr || '00:00'
            };
        }

        const ianaTimezone = timezoneMap[userTimezone] || userTimezone;
        const timeStr = utcTimeStr || '00:00';
        const utcDateTime = new Date(`${utcDateStr}T${timeStr}:00Z`);

        // Format the UTC date in user's timezone
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: ianaTimezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });

        const parts = formatter.formatToParts(utcDateTime);
        const getPart = (type) => parts.find(p => p.type === type)?.value || '00';

        return {
            localDate: `${getPart('year')}-${getPart('month')}-${getPart('day')}`,
            localTime: `${getPart('hour')}:${getPart('minute')}`
        };
    };

    const fetchSummaryData = async (startDate, endDate, startTime, endTime, company, timezone) => {
        incrementLoading();
        const tz = timezone || displayTimezone;
        try {
            // Convert user's local date/time to UTC before sending to API
            const utcStart = convertToUTC(startDate, startTime, tz);
            const utcEnd = convertToUTC(endDate, endTime, tz);

            const response = await axiosJWT.get(`${baseUrl}/call-pass-detail`, {
                params: {
                    startDate: utcStart.utcDate,
                    endDate: utcEnd.utcDate,
                    startTime: utcStart.utcTime,
                    endTime: utcEnd.utcTime,
                    company: company,
                    type: 2
                },
                headers: { Authorization: `Bearer ${token}` }
            });
            setSummaryData(response.data.summary || []);

            setSelectedDisplayIdentityForDrilldown(null);
            console.log("Fetched summary data based on all filters.");
        } catch (error) {
            console.error("Error fetching summary data:", error);
            // Handle error
        } finally {
            decrementLoading();
        }
    };

    const handleApplyFilters = () => {
        // Commit the pending timezone selection on Apply
        setDisplayTimezone(pendingDisplayTimezone);
        fetchSummaryData(startDate, endDate, startTime, endTime, selectedCompany, pendingDisplayTimezone);
    };

    const handleClearFilters = () => {
        setStartDate(getYesterday());
        setEndDate(new Date());
        setStartTime("00:00");
        setEndTime("23:59");
        setSelectedCompany("");
        setSelectedEntity("");
        setSelectedDisplayIdentity("");
        setSelectedOrigationNumber("");
        setDisplayTimezone('UTC');
        setPendingDisplayTimezone('UTC');
        fetchSummaryData(getYesterday(), new Date(), "00:00", "23:59", "", 'UTC');
    };

    const isDefaultDate = (date, defaultDateFunc) => {
        const defaultDate = defaultDateFunc();
        return date.getFullYear() === defaultDate.getFullYear() &&
               date.getMonth() === defaultDate.getMonth() &&
               date.getDate() === defaultDate.getDate();
    };
 
    const showClearButton = !isDefaultDate(startDate, getYesterday) ||
                            !isDefaultDate(endDate, () => new Date()) ||
                            startTime !== "00:00" ||
                            endTime !== "23:59" ||
                            selectedCompany !== "" ||
                            selectedEntity !== "" ||
                            selectedDisplayIdentity !== "" ||
                            selectedOrigationNumber !== "";    
    
    const gotoSwitchScreen = (e) => {
        e.preventDefault();
        
        const navigationState = {
            initialFilters: { // Current filter values from Summary page
                startDate: startDate.toISOString(), // Convert Date objects to string
                endDate: endDate.toISOString(),
                startTime,
                endTime,
                selectedCompany,
                selectedEntity,
                selectedDisplayIdentity,
                selectedOrigationNumber,
                displayTimezone: displayTimezone,
            }
        };

        navigate("/call-pass-branded-calling-details", { state: navigationState });
        
    }
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
            seTimeZone(decoded.timezone);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-4">
                            <div className="left-title">
                                <h1>Call Pass Summary</h1>
                            </div>
                        </div>
                        <div className="col-8 inventory-btn">
                            <div className="addnew-button">
                                <a href="#" style={{marginLeft: '10px',paddingBottom: '15px'}} onClick={(e) => gotoSwitchScreen(e)}>Call Pass Details</a>
                                <Link to="/dashboard"><span>&larr;</span>Dashboard</Link>
                            </div>
                        </div>
                        <div className="col-12">                            
                            <label>*Preliminary data - Not to be used for billing</label>
                        </div>
                    </div>

                    {/* Filter Section */}
                    <div className="common-white-shadow-background setting-section">
                        <div className="row filter-section align-items-end"> {/* All filters and buttons in this single row, align items to bottom */}
                             <div className="col-md-2">
                                <label>Start Date ({displayTimezone}):</label>
                                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" dateFormat="MM/dd/yyyy" />
                            </div>
                            <div className="col-md-2">
                                <label>Start Time ({displayTimezone}):</label>
                                <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} className="form-control" />
                            </div>
                            <div className="col-md-2">
                                <label>End Date ({displayTimezone}):</label>
                                <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} className="form-control" dateFormat="MM/dd/yyyy" />
                            </div>
                            <div className="col-md-2">
                                <label>End Time ({displayTimezone}):</label>
                                <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} className="form-control" />
                            </div>
                            <div className="col-md-2">
                                <label>Time Zone:</label>
                                <select value={pendingDisplayTimezone} onChange={(e) => setPendingDisplayTimezone(e.target.value)} className="form-control">
                                    <option value="UTC">UTC</option>
                                    {timeZone && timeZone !== 'UTC' && timeZone !== 'GMT' && (
                                        <option value={timeZone}>{timeZone}</option>
                                    )}
                                </select>
                            </div>
                            {role <=2 &&<div className="col-md-2">
                                <label>Company:</label>
                                <select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)} className="form-control">
                                <option value="" >Company</option>
                                    {company.map(option => (
                                        <option key={option.id} value={option.id}>{option.cname}</option>
                                    ))}
                                </select>
                            </div>}
                            <div className="col-md-2" style={{marginTop:"23px"}}> {/* Column for buttons */}
                                 {/* This inner div helps align buttons correctly, especially with align-items-end on the row */}
                                 {/* No explicit label needed here as align-items-end handles vertical positioning relative to other columns */}
                                 <div style={{ display: 'flex', justifyContent: 'flex-start', paddingBottom: '10px' }}> {/* Adjust paddingBottom to match input's effective bottom margin */}
                                 <button
                                         onClick={handleApplyFilters}
                                         className="search-btn"
                                         style={{
                                             width: 'auto', // Override .search-btn width: max-content (if needed for consistency)
                                             display: 'inline-block', // Override .search-btn display: block
                                             marginLeft: '0', // Override .search-btn margin-left: AUTO
                                             marginRight: '10px' // Ensure no extra right margin
                                         }}
                                     >
                                         Apply
                                     </button>
                                     {showClearButton && (
                                         <button
                                             onClick={handleClearFilters}
                                             className="search-btn clear-btn"
                                             style={{
                                                 marginRight: '10px',
                                                 width: 'auto', // Override .clear-btn fixed width
                                                 display: 'inline-block', // Override .search-btn display: block
                                                 marginLeft: '0' // Override .search-btn margin-left: AUTO
                                             }}
                                         >
                                             Clear
                                         </button>
                                     )}
                                     
                                 </div>
                             </div>
                        </div>
                        
                    </div>
                    

                    {/* Chart Section */}
                    {summaryData && summaryData.length > 0 && (
                        <div className="common-white-shadow-background setting-section" style={{marginTop: '20px'}}>
                            <CallPassCharts rawData={summaryData} selectedDisplayIdentityForDrilldown={selectedDisplayIdentityForDrilldown} onDisplayIdentityClick={handleDisplayIdentityClick} />
                        </div>
                    )}
                   
                </div>
            </div>            
        </div>
    )
}
 
export default CallPassBrandedCallingSummary;